import api from "./api/api";

const ChatService = {
  listarConversasRecentes: async (search?: string) => {
    try {
      const res = await api.get(
        `/chat/salas-recentes?s=${!!search ? search : ""}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  listarMensagens: async (
    id_conversa: string,
    page: number = 1,
    perPage: number = 20,
  ) => {
    try {
      const res = await api.get(
        `/chat/mensagens/${id_conversa}?page=${page}&perPage=${perPage}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Novo endpoint unificado para criar salas (individual e grupo)
  criarSala: async (payload: FormData) => {
    try {
      const res = await api.post("/chat/sala/criar", payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Novo endpoint para recuperar sala por ID
  recuperarSala: async (id_sala: string) => {
    try {
      const res = await api.get(`/chat/sala/recuperar/${id_sala}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Novo endpoint para atualizar sala
  atualizarSala: async (id_sala: string, payload: FormData) => {
    try {
      const res = await api.put(`/chat/sala/atualizar/${id_sala}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Endpoint antigo - manter para compatibilidade se necessário
  abrirConversa: async (id_user: any) => {
    try {
      const res = await api.get(`/chat/sala/${id_user}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  enviarMensagem: async (payload: FormData) => {
    try {
      const res = await api.post("/chat/enviarMensagem", payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Deletar mensagem (soft delete)
  deletarMensagem: async (messageId: string | number) => {
    try {
      const res = await api.delete(`/chat/mensagem/${messageId}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Listar arquivos da sala
  listarArquivos: async (
    roomId: string | number,
    page: number = 1,
    perPage: number = 20,
    type: "all" | "images" | "documents" | "others" = "all",
  ) => {
    try {
      const res = await api.get(
        `/chat/sala/${roomId}/arquivos?page=${page}&perPage=${perPage}&type=${type}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Listar links da sala
  listarLinks: async (
    roomId: string | number,
    page: number = 1,
    perPage: number = 20,
  ) => {
    try {
      const res = await api.get(
        `/chat/sala/${roomId}/links?page=${page}&perPage=${perPage}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  // Renomear arquivo
  renomearArquivo: async (
    messageId: string | number,
    fileIndex: number,
    displayName: string,
  ) => {
    try {
      const res = await api.put(`/chat/arquivo/${messageId}`, {
        fileIndex,
        displayName,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default ChatService;
